import { render, staticRenderFns } from "./SubmissionForm.vue?vue&type=template&id=42d6cebe"
import script from "./SubmissionForm.vue?vue&type=script&lang=js"
export * from "./SubmissionForm.vue?vue&type=script&lang=js"
import style0 from "./SubmissionForm.vue?vue&type=style&index=0&id=42d6cebe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports